import React, { useEffect, useState } from "react";
import {useStripe, useElements, Elements, PaymentElement} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import ENVIRONMENT from '../../../../environments';
import axios from 'axios';
import { Button } from "antd";
import { LoadingOutlined, WarningOutlined } from "@ant-design/icons";
import DottedLoader from "../../DottedLoader";
import $ from 'jquery';
import FileConstants from '../../../../FileConstants';

// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(ENVIRONMENT.STRIPE_PUBLISH_KEY);

// Callback handler component
const CallbackHandler = (props) => {
  const stripe = useStripe();
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get('setup_intent_client_secret');
    
    if (!clientSecret) {
      setProcessing(false);
      return;
    }

    stripe.retrieveSetupIntent(clientSecret).then(({setupIntent}) => {
      switch (setupIntent.status) {
        case 'succeeded':
          let setupIntentValue = new URLSearchParams(window.location.search).get('setup_intent');
          axios.post(ENVIRONMENT.SAVE_CARD_CALLBACK, {
            username: localStorage.getItem('username'),
            request_id: props.request_id,
            setup_intent_secret: setupIntentValue
          }).then(res => {
            axios.post(ENVIRONMENT.GET_USER_PAYMENT_INFORMATION, {
              'action': 'delete_previous', 
              'username': localStorage.getItem('username')
            }).then(() => {
              if (props.request_type == 'card_save_window') {
                let action = new URLSearchParams(window.location.search).get("action");
                window.opener.dispatchEvent(new CustomEvent('card_saved', {'detail': {'action': action}}));
                window.close();
              } else if (props.request_type == 'sign_up_flow') {
                let plan = new URLSearchParams(window.location.search).get("plan");
                let isAnnual = false;
                let subscriptionPlanType = new URLSearchParams(window.location.search).get("subscriptionType");
                let bundleQuantity = new URLSearchParams(window.location.search).get("bundleQuantity");
                
                if (subscriptionPlanType && subscriptionPlanType.includes('annual_') && plan == 'subscription'){
                  isAnnual = true;
                } else if (plan == 'subscription'){
                  isAnnual = false;
                }
                
                let payload = {
                  subscription_type: plan,
                  username: localStorage.getItem('username'),
                  annual_subscription: isAnnual
                }
                if(subscriptionPlanType == 'bundle' && bundleQuantity){
                  payload['bundle_quantity'] = bundleQuantity
                }
                axios.post(ENVIRONMENT.UPGRADE_SUBSCRIPTION, payload).then(() => {
                  setProcessing(false);
                  if (props.onSuccess) props.onSuccess();
                  // Clean up URL params
                  const newUrl = window.location.origin + window.location.pathname;
                  window.history.replaceState({}, document.title, newUrl);
                });
              } else {
                setProcessing(false);
                if (props.onSuccess) props.onSuccess();
                // Clean up URL params
                const newUrl = window.location.origin + window.location.pathname;
                window.history.replaceState({}, document.title, newUrl);
              }
            });
          });
          break;
        case 'processing':
          setProcessing(true);
          break;
        case 'requires_payment_method':
          setProcessing(false);
          if (props.onError) props.onError('Failed to process payment details. Please try another payment method.');
          break;
      }
    });
  }, [stripe]);

  if (processing) {
    return <DottedLoader />;
  }

  return null;
};

const SetupForm = (props) => {
    const [buttonLoader,setButtonLoader] = useState(false);
    const [loader, setLoader] = useState(true);
    const [isFormReady, setIsFormReady] = useState(false);
    const stripe = useStripe();
    const elements = useElements();
    console.log(stripe,elements)

    const [errorMessage, setErrorMessage] = useState(null);

    const handleSubmit = async ( request_id, request_type) => {
      // We don't want to let default form submission happen here,
      // which would refresh the page.
      setButtonLoader(true);

      if (!stripe || !elements) {
        console.log(stripe,elements)
        // Stripe.js has not yet loaded.
        // Make sure to disable form submission until Stripe.js has loaded.
        return;
      }
      console.log('Request ID and Type: ', request_id, request_type);
      // Build return URL that redirects to current route with necessary parameters
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('request_id', request_id);
      currentParams.set('request_type', request_type);
      
      // Add additional parameters for sign_up_flow
      if (request_type == 'sign_up_flow') {
        currentParams.set('plan', props.plan);
        currentParams.set('subscriptionType', props.subscriptionType);
        currentParams.set('bundleQuantity', props.bundleQuantity);
      }
      
      let returnUrl = window.location.origin + window.location.pathname + '?' + currentParams.toString();
      console.log('Return URL:', returnUrl)
      const {error} = await stripe.confirmSetup({
        //`Elements` instance that was used to create the Payment Element
        elements,
        confirmParams: {
          return_url: returnUrl,
        }
      });
      console.log('ERROR',error)
      
      if (error) {
        setButtonLoader(false);
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
        setErrorMessage(error.message);
        props.setErrorMessage(error.message);
        // if (props.setCardSaveFailure != undefined) {
        //   props.setCardSaveFailure(true);
        // }
        console.log(error.message);
      } else {
        setButtonLoader(false);
        // if (props.setCardSaveFailure != undefined) {
        //   props.setCardSaveFailure(true);
        // }
        console.log('Redirected URL')
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
      }
    };

    const handleEntityCreation = (event) => {
      event.preventDefault();
      setButtonLoader(true);
      if (props.account_details_form) {
        handleSubmit(-1,'account_details');
      } else {
        if (props.card_save_window) {
          handleSubmit(-1,'card_save_window');
        } else {
          if (props.signUpFlow) {
            handleSubmit(-1,'sign_up_flow');
          }
        }
        if (props.saveRequestIntermedietely != undefined){
          props.saveRequestIntermedietely(handleSubmit)
        }
      }
    }

    const setPageLoaded  = () => {
      setIsFormReady(true);
    }
    
    return (
      stripe || elements ?
      <span>
        <form onSubmit={handleEntityCreation}>
          <PaymentElement id="payment-element" onReady={() => setPageLoaded()}/>
          <Button htmlType="submit" disabled={!stripe || !elements || buttonLoader} style={{marginTop: 30, display: (isFormReady? 'block': 'none')}} className={`modal-okay square font-16 justify-in-center ${props.account_details_form ? ``: `important-width`}`}>
            {!props.signUpFlow ? 'Save Card' : `Pay $${props.totalAmount?.toLocaleString()}`} {buttonLoader ? <LoadingOutlined/> : ''}
          </Button>
        </form>
        {(!isFormReady && props.account_details_form)?<DottedLoader/>:''}
      </span>
      
      : ''
    );
};

const SaveCardFlow = (props) => {

  const [options, setOptions] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [cardSaved, setCardSaved] = useState(false);

  // Check if we're returning from Stripe callback
  const hasCallback = new URLSearchParams(window.location.search).get('setup_intent_client_secret');
  const request_id = new URLSearchParams(window.location.search).get('request_id');
  const request_type = new URLSearchParams(window.location.search).get('request_type');

  // Check if card was just saved (from sessionStorage)
  useEffect(() => {
    const cardJustSaved = sessionStorage.getItem('cardJustSaved');
    if (cardJustSaved === 'true') {
      setCardSaved(true);
      sessionStorage.removeItem('cardJustSaved');
      setTimeout(() => {
        setCardSaved(false);
      }, 2000);
    }
  }, []);

  useEffect(() => {
    if (!hasCallback) {
      axios.post(ENVIRONMENT.SAVE_CARD_FLOW, {
        username: localStorage.getItem('username')
      })
        .then(res => {
          setOptions({
            clientSecret: res.data,
            appearance: {/*...*/},
          });
      });
    }
  },[hasCallback]);

  const handleSuccess = () => {
    // Store success flag in sessionStorage before reload
    sessionStorage.setItem('cardJustSaved', 'true');
    // Clean up URL params and reload
    const newUrl = window.location.origin + window.location.pathname;
    window.location.href = newUrl;
  };

  const handleError = (error) => {
    setErrorMessage(error);
  };

  if (hasCallback && request_id && request_type) {
    return (
      <Elements stripe={stripePromise}>
        <CallbackHandler 
          request_id={request_id} 
          request_type={request_type}
          onSuccess={handleSuccess}
          onError={handleError}
        />
      </Elements>
    );
  }

  if (cardSaved) {
    return (
      <div className="success-message">
        <p className="manrope f-16 green">Card saved successfully!</p>
      </div>
    );
  }

  return (
    <span>
      {(options != null) ?
      <Elements stripe={stripePromise} options={options}>
        {errorMessage && 
        <div className="payment-error justify-in-start">
          <WarningOutlined className="manrope red" />
          <p className="manrope f-14 lh-22 red mb-0 ml-4">{errorMessage}</p>
        </div>}
        <SetupForm 
        totalAmount={props.totalAmount} 
        setCardSaveFailure={props.setCardSaveFailure} 
        saveRequestIntermedietely={props.saveRequestIntermedietely} 
        account_details_form={props.account_details_form} 
        card_save_window={props.card_save_window} 
        setErrorMessage={setErrorMessage} 
        plan={props.plan} 
        signUpFlow={props.signUpFlow} 
        subscriptionType={props.subscriptionType}
        bundleQuantity={props.bundleQuantity}/>
      </Elements> : props.account_details_form ? <DottedLoader/> : <LoadingOutlined className="manrope f-16 black-55"/>
      }
      
    </span>
  );
};

export default SaveCardFlow;